module.exports = __webpack_public_path__ + "img/物料发票示例.cd29dc14.png";